import { render, staticRenderFns } from "./SendProductArtworkToVendor.vue?vue&type=template&id=e776b866&scoped=true&"
import script from "./SendProductArtworkToVendor.vue?vue&type=script&lang=js&"
export * from "./SendProductArtworkToVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e776b866",
  null
  
)

export default component.exports